module.exports = __webpack_public_path__ + "img/file-slash.a94304b1.svg";